import { Control, FieldValues, Path, useController } from 'react-hook-form';
import styled, { css } from 'styled-components';

import { Input, Label } from '@/components/Forms';
import ValidationMessage from '@/components/Forms/ValidationMessage';

const Options = styled.div`
  display: grid;
  grid-template-columns: repeat(5, minmax(0, 1fr));
  gap: 8px;
`;

const Option = styled(Input)<{ $active: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  ${({ theme, $active }) =>
    $active &&
    css`
      border-color: ${theme.colors.purple} !important;
      color: ${theme.colors.purple};
    `}
`;

const options = [1, 2, 5, 12, 24];

interface Props<T extends FieldValues> {
  control: Control<T>;
  name: Path<T>;
}

const FpsField = <T extends FieldValues>({ control, name }: Props<T>) => {
  const {
    field: { onChange, value },
    fieldState: { error },
  } = useController({
    control,
    name,
  });
  return (
    <div>
      <Label>Frames per second (FPS)</Label>
      <Options>
        {options.map((option) => (
          <Option
            key={option}
            as="button"
            type="button"
            onClick={() => onChange(option)}
            $active={value === option}
            $small
          >
            {option} FPS
          </Option>
        ))}
      </Options>
      {!!error && <ValidationMessage>{error.message}</ValidationMessage>}
    </div>
  );
};

export default FpsField;
